import { createRouteRef } from '@backstage/core-plugin-api';

export const entityRouteRef = createRouteRef({
  id: 'appfolio.code-ownership.entity',
});
